import { IMarket } from '@audacy-clients/core/atoms/location';

export const getMarketIdsString = (markets: IMarket[]) =>
  markets.map((market) => market.marketId).join('|');
